import { LiaShoppingBagSolid } from "react-icons/lia";
import {storeName,Storecolors,logo} from '../Var/config.js'
import {Link, useLocation, useNavigate, } from 'react-router-dom'
import { IconContext } from "react-icons";
import '../Assets/Style.css'
import { useEffect, useRef, useState } from "react";
import React from 'react';
import { Search, User} from 'lucide-react';
import menuItems from "./DropdownItems.jsx";
import { Shopcontext } from "../pages/Root/Shop/Shop.jsx";
import { useContext } from "react";
import { Menu, X } from 'lucide-react';
import Tbreveal from "./Tbreveal.jsx";
import { use } from "react";
import gsap from "gsap";
const Header = ({userR,setDarkMode,isDarkMode,textLeave,textEnter,setloadPre,showPreloader}) => {
    let [showList,setShow] = useState(false)
    let [searchParams,setSearchParams] = useState('')
    let ShopData = useContext(Shopcontext)
    const location = useLocation();
    const navigate = useNavigate();
    const [isMenuOpen, setIsOpen] = useState(false);
    const [mdiconVisible, setIsVisible] = useState(false);
    const [smallsizw, setsmallsizw] = useState(false);
    const [Trigger, setTrigger] = useState(false);
    const [loading, setloading] = useState(true);
    const underlineRef = useRef();
    const reveal = useRef();
    const changeTheme = (theme) => {
        setDarkMode(!isDarkMode)
    };
    function trigger(e) {
        setTrigger(!Trigger)
    }
    useEffect(()=>{
        const isReload = sessionStorage.getItem("isReload");
        if(showPreloader && reveal.current && isReload == "true" && location.pathname == "/"){
            gsap.fromTo(
            reveal.current,{
                opacity: 0,

            },
    {
                opacity: 1,
                delay: 4.6,
                ease:"power2.out",
                duration: 3.5,
            }
            );
        }
    },[showPreloader,reveal.current])
    useEffect(()=>{
        const isReload = sessionStorage.getItem("isReload");
        if(underlineRef?.current && showPreloader && isReload == "true" && location.pathname == "/"){
        gsap.fromTo(underlineRef.current,     { width: 0 },        
            { width: "100%",     
                duration: 5,
                ease: "power2.out",
                yoyo:true,
                onStart: ()=>{
                    sessionStorage.setItem("isReload", "false");
                },
            })
        }
    },[underlineRef.current,showPreloader])
    useEffect(() => {
      const handleResize = () => {
        if(window.innerWidth <= 768){
            setIsVisible(true); // Show only if less than md
            setsmallsizw(true)
        }else{
            setIsVisible(false); // Show only if more than md
            setsmallsizw(false)
        }
    };
      setloading(false)
      handleResize(); 
      window.addEventListener("resize", handleResize);
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    if(loading){
        return <></>
    }
    const maskStyle = ["/signup","/login"].includes(location.pathname)
    ? {
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 20%, black 100%)',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskSize: '100% 100%',
        maskImage: 'linear-gradient(to right, transparent 0%, black 20%, black 100%)',
        maskRepeat: 'no-repeat',
        maskSize: '100% 100%',    
        }
    : {}; 
    return (
        <header className={`${!["/signup","/login"].includes(location.pathname) ? "bg-mainele" : !isDarkMode &&"bg-mainele"}  border-gray-700 sticky top-0 z-50 flex flex-center flex-col flex-nowrap`} >
            <div
 className={`NN-main-header ${!["/signup","/login"].includes(location.pathname) && "bg-mainele"} 
    `}>
              <div
        ref={underlineRef}
        className={`absolute left-0 bottom-0 h-[1px] bg-one ${(sessionStorage.getItem("isReload") == "false" || location.pathname != "/" )&& "w-full"}`}
      />
                <div className="flex items-center h-16 justify-between" style={maskStyle}>
                    <div className="flex items-center space-x-8">
                        <h1 className="le-side-header text-one ">
                            <Link ref={reveal} onMouseEnter={textEnter} onMouseLeave={textLeave} className={` ${location.pathname ==  '/' ? sessionStorage.getItem("isReload") == "false" ?  "opacity-1" : "opacity-0" : "opacity-1"}`} to={'/'} >{storeName}</Link></h1>
                <div className="relative flex-1 max-w-xl">
                    <button className="absolute inset-y-0 left-0 pl-3 flex items-center" onClick={trigger}>
                        <Search onMouseEnter={textEnter} onMouseLeave={textLeave} className={`h-5 w-5 text-${!Trigger ? 'one':'mainele'}`}/>
                    </button>
                    <input
                    onMouseEnter={textEnter} onMouseLeave={textLeave} 
                    onChange={(e)=>setSearchParams(e.target.value)}
                    type="text"
                    className={`${Trigger ? 'block' : 'hidden'} transition duration-300 ease-in-out w-full pl-10 pr-3 py-2 border rounded-lg bg-one text-mainele placeholder-gray-400 focus:outline-none`}
                    placeholder="Search items, collections, and accounts"
                    />
                    <div className={`absolute ${(searchParams && ShopData) ? 'block' : 'hidden'} min-w-fit w-[60vw] min-h-fit h-[10vh]`}>
                    {(searchParams && ShopData) && ShopData.map((item)=>{
                        if((item.name.toLowerCase().replaceAll(' ','')).includes(searchParams.toLowerCase().replaceAll(' ',''))){
                            return <li className="bg-one">
                                            <Link onMouseEnter={textEnter} onMouseLeave={textLeave} className="w-full h-full bg-one flex items-center" to={`/items/${item._id}`}>
                                                <img draggable='false'
                                                src={item.img[0]}
                                                alt={`${item.name} photo`}
                                                className={`w-[10vw] h-[10vw] block object-cover`}
                                                />
                                          <div className="ml-3 h-full">
                                                <h1 className="font-medium text-mainele">{item.name}</h1>
                                                <p className="ml-2 font-medium text-red-800">{item.desc}</p>
                                          </div>
                                            </Link>
                            </li>
                        }
                    })}
                            </div>
                        </div>
                    </div>
                </div>
                {!mdiconVisible &&
            <ol className="flex items-center space-x-6 px-170">
                {!userR && !['/login','/signup'].includes(location.pathname) ?
                    // what an unregestried user sees
                 <><div onMouseEnter={textEnter} onMouseLeave={textLeave} className="w-full text-left flex items-center justify-between hover:bg-gray-700 transition duration-300 ease-in-out rounded-lg "> 
                    <Link className="text-one px-6 w-full h-full py-2 " to="/login" onClick={()=>setloadPre(true)}>Login</Link>
                </div> 
                <div onMouseEnter={textEnter} onMouseLeave={textLeave} className="w-full text-left flex items-center justify-between hover:bg-gray-700 transition duration-300 ease-in-out rounded-lg"> 
                    <Link className="text-one px-6 w-full h-full py-2 " to="/signup"  onClick={()=>setloadPre(true)}>SignUp</Link>
                </div></>:
                <> 
                     {/* what a user sees */}
                    {/* <Link className="text-one py-1 px-2" to={'/profile'}>Profile</Link>  */}
                    {/* <a className="text-one py-1 px-2"  href="/logout">Logout</a> */}
                </>}
            <div id="tk" onMouseOut={()=>setIsOpen(false)} onMouseOver={()=>setIsOpen(true)}>
                <li style={{'cursor':'pointer'}} onMouseEnter={textEnter} onMouseLeave={textLeave} className="text-one no-underline cursor-pointer text-interactive-primary hover:text-interactive-primary-hover disabled:pointer-events-none disabled:opacity-40 sc-28e98bbc-0 CrMKY ml-3 flex items-center justify-center" 
                    onClick={()=>setShow(!showList)}
                    >
                        <div className="flex flex-col justify-center items-center"><IconContext.Provider value={{size:"6px"}} > <User className="h-6 w-6"/></IconContext.Provider>
                        </div>
                </li>
                {(isMenuOpen || showList) && (
                    <div
                    id="IK"
                    className="absolute z-[3] mt-2 w-[18rem] transition-all bg-transparent top-[136px] pt-4 right-[43px]"
                    style={{ transform: "translate(-50px,-83px)"}}
                    >
                    <div
                        className="mt-2 w-full bg-mainele rounded-lg shadow-lg py-2 "
                        style={{ visibility: "visible", inset: "0px 0px auto auto", margin: "0px" }}
                    >
                        <ul className="w-full h-full py-2 rounded-[12px] text-left flex flex-col items-center justify-between">
                        {menuItems.map((Obj,index)=>{
                            if(Obj.divider){
                                return <hr key={index} className="my-2 w-full border-1 border-one"/>
                            }
                            if(Obj.require && !userR){
                                return 
                            }
                            if(Obj.label == 'Cart'){
                                return 
                            }
                            if(Obj.admin && userR != 'admin'){
                                return 
                            }  if(Obj.href){
                                return  <a
                                key={index}
                                href={Obj.href}
                                className="flex w-full items-center space-x-3 block px-3 py-2 font-medium text-dropitems hover:bg-dropitems duration-300 ease-in-out transition-all hover:text-mainele">
                                <span className="flex-1">{Obj.label}</span>
                                <span>{Obj.icon}</span>              
                                    {Obj.suffix &&  (<span className="text-sm text-gray-500">{Obj.suffix}</span> )}
                                    {Obj.toggle && (
                                        <button onClick={changeTheme}>
                                            <div className={`w-10 h-6 rounded-full p-1 ${isDarkMode ? 'bg-blue-500' : 'bg-gray-300'}`}>
                                            <div className={`w-4 h-4 rounded-full bg-white transform transition-transform ${isDarkMode ? 'translate-x-4' : 'translate-x-0'}`} />
                                        </div>
                                        </button>
                                    )}
                                </a>
                            }
                            return <li key={index} onClick={() => Obj.link && navigate(`${Obj.link}`)} onMouseEnter={textEnter} onMouseLeave={textLeave} className="w-full cursor-pointer flex w-full items-center space-x-3 px-4 py-2 text-left flex items-center justify-between text-dropitems hover:bg-dropitems duration-300 ease-in-out transition-all  hover:text-mainele">
                                    <span >{Obj.icon}</span>
                                    <span className="flex-1 ">{Obj.label}</span>
                                    {Obj.suffix && (<span className="text-sm text-gray-500">{Obj.suffix}</span> )}
                                    {Obj.toggle && (
                                        <button onClick={changeTheme}>
                                            <div className={`w-10 h-6 rounded-full p-1 ${isDarkMode ? 'bg-blue-500' : 'bg-gray-300'}`}>
                                            <div className={`w-4 h-4 rounded-full bg-white transform transition-transform ${isDarkMode ? 'translate-x-4' : 'translate-x-0'}`} />
                                        </div>
                                        </button>
                                    )}
                        </li>
                        })}
                        </ul>
                    </div>
                    </div>
                )}</div>
                <li onClick={()=>setShow(false) } className="text-one" onMouseEnter={textEnter} onMouseLeave={textLeave}><Link to={'/cart'} ><IconContext.Provider  value={{ size:"29px" }}> <LiaShoppingBagSolid /></IconContext.Provider> </Link></li>
            </ol>}
             {(mdiconVisible && smallsizw) && 
            <div className="flex items-center">
                <button 
                onMouseEnter={textEnter} onMouseLeave={textLeave}
                onClick={()=>{
                    setShow(!showList)
                }}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-gray-600 focus:outline-none"
                >
                {(!showList) && (
                    <Menu className="block h-6 w-6 text-one" aria-hidden="true" />
                )}
                </button>
            </div>
        }
        </div>
        {(showList && smallsizw) && 
      <div className={`block bg- shadow-lg fixed top-0 left-0 w-screen h-screen z-50`}>
            <div className="px-2 pt-2 pb-3 space-y-1 bg-black sm:px-3  h-screen  w-[100vw] flex items-center flex-col overflow-y-auto">
            <button
                onClick={()=>{
                  setShow(!showList)
                }} 
                className="block py-[15px] mb-[30px] px-[46px] place-self-end h-6 w-6 text-white">
                    <X aria-hidden="true" />
                </button>
           <div className='flex flex-col divide-y w-full h-full divide-white divide-opacity-10 border-t border-white border-opacity-10 border-b  js-menu-inner'> 
            {menuItems.filter((Obj) => {
                if ((Obj?.require && !userR) || Obj?.toggle) return false;
                if ((Obj?.admin && userR !== 'admin') || (!Obj.renderforadmin && userR == 'admin')) return false;
                return true;})
                .map((Obj,index)=>{
                if(Obj.divider){
                return <hr key={index} className="my-2 w-full border-1 border-one"/>
                }
            let delay = index * .3
              return <Tbreveal key={index} delay={delay}>  {Obj.href ?
                                <a
                                href={Obj.href}
                                target="_blank" rel="noopener noreferrer"
                                className="flex w-full font-Main items-center space-x-3 block px-3 py-20 text-3xl text-white">
                                {Obj.label}
                                </a> : <Link
                                onClick={()=>setShow(false)}
                                to={Obj.link}
                                className="flex w-full font-Main items-center space-x-3 block px-3 py-20 text-3xl text-white">
                                {Obj.label}
                                </Link> }</Tbreveal>
                }
                              )}
                              </div>
                

            </div>
                </div>}
                {/* <a
                    href="#"
                    className="text-dropitems hover:bg-dropitems hover:text-mainele block px-3 py-2 rounded-md font-medium"
                >
                    Model 3
                </a>
                <a
                    href="#"
                    className="text-dropitems hover:bg-dropitems hover:text-mainele block px-3 py-2 rounded-md font-medium"
                >
                    Model X
                </a> */}

        </header> 

    )
}

export default Header